// Module
var code = "<div class=\"gc-tooltip\"> <div class=\"gc-tooltip-tail\"></div> {{ progressbar }} {{ title }} {{ description }} {{ close }} {{ customButtons }} <div if=\"previous || pagination || next\" class=\"gc-navigation\"> {{ previous }} {{ pagination }} {{ next }} </div> {{ copyright }} {{ notification }} </div>";
// Exports
export default code;